const cabinetAside = document.querySelector('.js--cabinet_aside');
const $closeLevelTop = document.querySelectorAll('.js--close_level_top');
const $body = document.body;
const $root = document.getElementsByTagName( 'html' )[0];
const $screen = document.querySelector('.screen');
const menuTrigger = document.querySelectorAll('.js--cabinet__header_burger');

if (cabinetAside) {
  const openPushNav = () => {
    cabinetAside.classList.add('isOpen');
    $body.classList.add('menuIsOpen');
    $root.classList.add('menuIsOpen');
  };

  menuTrigger.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      // e.stopPropagation();
      if (cabinetAside.classList.contains('isOpen')) {
        closePushNav();
      } else {
        openPushNav();
      }
    });
  });

  const closePushNav = () => {
    cabinetAside.classList.remove('isOpen');
    $body.classList.remove('menuIsOpen');
    $root.classList.remove('menuIsOpen');
  };


  $closeLevelTop.forEach(closeTop => {
    closeTop.addEventListener('click', closePushNav);
  });

  $screen.addEventListener('click', closePushNav);
}
